import React from 'react'
import { intl } from 'lang/intl'
import classnames from 'classnames'

import { TtDialog } from '@23/react'

import { useModal } from '.'

import './Modal.scss'

const Modal = () => {
  const { content, setContent, isOpen, setIsOpen } = useModal()

  return (
    <TtDialog
      className={classnames([`classic-product-modal`, content?.className])}
      label={
        typeof content?.label === 'string'
          ? content?.label
          : intl.formatMessage({
              defaultMessage: 'Dialog',
              description: 'Modal popup',
            })
      }
      noHeader={!content?.label}
      open={isOpen}
      alert={content?.isAlert}
      closable={content?.closable ?? !content?.isAlert}
      onTt-hide={(event) => {
        if (event.target === event.currentTarget) {
          setIsOpen(false)
        }
      }}
      onTt-after-hide={(event) => {
        if (event.target === event.currentTarget) {
          content?.onClose?.()
          setContent(null)
        }
      }}
    >
      {content?.body}
    </TtDialog>
  )
}

export { Modal }
